<!--  -->
<template>
  <div>
    <div class="company_box">
      <div class="daewr">企业名称：</div>
      <el-input v-model="input" style="width:650px" placeholder="请输入企业名称" />
    </div>
    <el-button class="sdaew_btn" type="primary" @click="companybtn">确定</el-button>
    <div class="table_box">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="corpName"
          label="公司名称"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.corpName }}</span>
            <el-input v-else v-model="scope.row.textCorpName" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        >
          <template slot-scope="scope">
            <el-button v-show="!scope.row.isModify" type="text" size="mini" @click="edit(scope.row)">修改</el-button>
            <el-button v-show="!scope.row.isModify" type="text" size="mini" @click="delte(scope.row.id)">删除</el-button>
            <el-button v-show="!scope.row.isModify" type="text" size="mini" @click="updatadepartment(scope.row)">更新部门</el-button>
            <el-button v-show="!scope.row.isModify" type="text" size="mini" @click="updatastaff(scope.row)">更新员工</el-button>
            <span v-show="scope.row.isModify">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="(scope.row.isModify = false),(scope.row.textCorpName = scope.row.corpName)"
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.row)"
              >
                确认修改
              </el-button>
            </span>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { anonymousadd, enterpriselist, updataapplication, updataemployee, enterpriseupdate, deltedestroy } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      input: '', // 企业名称
      total: null, // 总页数
      query: { // 传递的参数
        page: 1,
        pageSize: 10
      },
      tableData: []
    }
  },
  created() {
    this.getenterpriselist()
  },
  mounted() {

  },
  methods: {
    // 获取企业列表
    async getenterpriselist() {
      const data = await enterpriselist(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textCorpName = data.data.list[i].corpName
        data.data.list[i].isModify = false
      }
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getenterpriselist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getenterpriselist()
    },
    async companybtn() {
      if (this.input === '') {
        this.$message.error('请输入企业名称')
        return
      }

      const data = await anonymousadd({
        corpName: this.input
      })
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      // this.$emit('close')
      this.getenterpriselist()
      this.input = ''
      console.log('data', data)
    },
    edit(row) {
      row.isModify = true
    },
    // 更新部门
    async updatadepartment(row) {
      console.log('row', row)
      const data = await updataapplication({
        corpId: row.id
      })
      this.$message({
        message: '更新部门成功',
        type: 'success'
      })
      console.log('data', data)
    },
    // 更新员工
    async updatastaff(row) {
      console.log(row)
      const data = await updataemployee({
        corpId: row.id
      })
      this.$message({
        message: '更新员工成功',
        type: 'success'
      })
      console.log('data', data)
    },
    async confirmAccount(row) {
      console.log('row', row)
      const data = await enterpriseupdate({
        id: row.id,
        corpName: row.textCorpName
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getenterpriselist()
      console.log('data', data)
    },
    delte(id) {
      this.$confirm('确定要删除此企业吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deltedestroy({
          id: id
        }).then(() => {
          this.getenterpriselist()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.company_box{
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
}
.sdaew_btn{
  margin: 30px 0px 0px 600px;;
}
.daewr{
  font-size: 14px;
}
.table_box{
  padding: 10px;
}
</style>
